import $ from 'jquery';

export default function() {
  $(document).on('click', '.add-subscription-block span, .add-subscription-block svg', function(){
    $('#ReCharge').remove();
    $('#shopify-section-product-add-subscription').show();
    const $productSlider = $('[data-ps-subscription]');
    const $productThumbSlider = $('[data-thumb-subscription]');
    if ($productSlider.length) {
        $productSlider.on('init', function() {
        $productSlider.addClass('is-visible');
        })
        const slider = $productSlider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.product-thumbs-slider'
        });
        const thumbSlider = $productThumbSlider.slick({
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        asNavFor: '.product-slider'
        })
    }

    $('[data-all-variants]').trigger('change');

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;

    $('[data-charge-date]').val(today);
  });

  $('[data-add-to-subscription]').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    var url = '/tools/recurring/portal/' + window.customerHash + '/request_objects?token=' + window.customerToken;
    $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: { schema: '{ "addresses": { "discount": { "id": "parent.discount_id" }}, "customer": {}, "settings": {} }' }
    }).done(function(response) {
        // Successful request made
        const addressId = response['addresses'][0]['id'];
        const variantId = $('[data-all-variants]').val();
        let quantity = 4;
        const chargeDate = $('[data-charge-date]').val();
        if($('[data-product-option=1]').val() == 'Duo' ) {
            quantity = 2;
        }
        url = '/tools/recurring/portal/' + window.customerHash + '/subscriptions?token=' + window.customerToken;
        $.ajax({
            type: 'post',
            url: url,
            dataType: 'json',
            data: { 
                shopify_variant_id: variantId,
                order_interval_frequency: "4",
                order_interval_unit: "month",
                charge_interval_frequency: 4,
                next_charge_scheduled_at: chargeDate,
                address_id: addressId,
                quantity: 4
            }
        }).done(function(response) {
            // Successful request made
            window.console.log(response);
            window.location.href = '/tools/recurring/login';
            return response;
        }).fail(function(response) {
            // Request failed
            window.console.error(response);
            return response;
        }).always(function() {
            delete window.locked;
        });

    }).fail(function(response) {
        // Request failed
        window.console.error(response);

    });

  });
}